import schema from '@/nebula/schema';

export default Object.keys(schema);
